import React from 'react';
import { useToast } from '../../context/ToastContext';

const ICONS = {
  success: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
      <path d="M20 6L9 17l-5-5" />
    </svg>
  ),
  error: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
      <path d="M18 6L6 18M6 6l12 12" />
    </svg>
  ),
  info: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
      <path d="M12 16v-5M12 8h.01" />
      <circle cx="12" cy="12" r="9" />
    </svg>
  ),
};

// Az ikon kap egy színes kis lapot — így a toast szövege semleges maradhat,
// és nem lesz belőle színes falfelület.
const ICON_STYLES = {
  success: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/25',
  error:   'bg-red-500/15 text-red-300 border-red-500/25',
  info:    'bg-brand-500/15 text-brand-200 border-brand-400/25',
};

const ACCENT = {
  success: 'from-emerald-400/70',
  error:   'from-red-400/70',
  info:    'from-brand-400/70',
};

export default function ToastContainer() {
  const { toasts, removeToast } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed top-20 right-0 z-[100] flex flex-col gap-2.5 max-w-sm w-full px-4">
      {toasts.map(t => (
        <div
          key={t.id}
          onClick={() => removeToast(t.id)}
          role="status"
          className="group relative flex items-start gap-3 p-3.5 pr-10 rounded-xl overflow-hidden
                     bg-gray-900/85 backdrop-blur-xl border border-white/[0.09]
                     shadow-card-lg cursor-pointer animate-toast-in
                     hover:border-white/[0.16] transition-colors"
        >
          {/* Bal oldali színcsík adja a típus jelzését */}
          <span className={`absolute inset-y-0 left-0 w-px bg-gradient-to-b to-transparent ${ACCENT[t.type] || ACCENT.info}`} />

          <span className={`flex-shrink-0 w-7 h-7 rounded-lg border flex items-center justify-center
                            ${ICON_STYLES[t.type] || ICON_STYLES.info}`}>
            {ICONS[t.type] || ICONS.info}
          </span>

          <p className="text-sm text-gray-200 leading-snug pt-1">{t.message}</p>

          <span className="absolute top-3 right-3 text-gray-600 group-hover:text-gray-300 transition-colors">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" className="w-3.5 h-3.5">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </span>
        </div>
      ))}
    </div>
  );
}
